import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BookingAddressData } from 'src/app/models/booking/address-data.model';
import { CommandEnum } from 'src/app/models/common/enums/command.enum';
import { CommandService } from 'src/app/services/common/command.service';
import { StorageService } from 'src/app/services/common/storage.service';
import { ParticleService } from 'src/app/services/particle/particle.service';
import { AuthService } from 'src/app/services/user/auth.service';
import { CardService } from 'src/app/services/user/card.service';
import { ServicesComponent } from '../services.component';

@Component({
    selector: 'booking-services-desktop',
    templateUrl: './services-desktop.component.html',
    styleUrls: ['./../services.component.scss', './services-desktop.component.scss'],
    standalone: false
})
export class ServicesDesktopComponent extends ServicesComponent {
  address: BookingAddressData = new BookingAddressData();
  donateBags: number;
  AddInst: string;
  EditInst: string;
  AddDonation: string;
  saveInstNext: string;
  

  constructor(
    protected particleService: ParticleService,
    protected commandService: CommandService,
    protected router: Router,
    protected cardService: CardService,
    protected route: ActivatedRoute,
    protected authService: AuthService,
    public storageService: StorageService,
    protected deviceDetectorService: DeviceDetectorService,
  ) {
    super(particleService, commandService, storageService, router, cardService, route, authService, deviceDetectorService);
  }

  async ngOnInit() {
    await super.ngOnInit();
    this.address.donateBags = this.storageService.getObject('adresse').donateBags;
    this.donateBags = this.address.donateBags;

    var firstName = localStorage.getItem('firstName');
    let smsMarketing = localStorage.getItem('smsMarketing')
    if (smsMarketing){
      this.AddInst="sms-marketing-booking-redirectToSummary-editGarmentIns-addInst";
      this.EditInst= "sms-marketing-booking-redirectToSummary-editGarmentIns-EditInst";
      this.AddDonation= "sms-marketing-booking-redirectToSummary-editGarmentIns-addDonation";
      this.saveInstNext = "sms-marketing-booking-redirectToSummary-editGarmentIns-next";
    }else if( firstName){
      this.AddInst="returning-user-booking-redirectToSummary-editGarmentIns-addInst";
      this.EditInst= "returning-user-booking-redirectToSummary-editGarmentIns-EditInst";
      this.AddDonation= "returning-user-booking-redirectToSummary-editGarmentIns-addDonation";
      this.saveInstNext = "returning-user-booking-redirectToSummary-editGarmentIns-next";
    }else{
      this.AddInst="first-journey-booking-redirectToSummary-editGarmentIns-addInst";
      this.EditInst= "first-journey-booking-redirectToSummary-editGarmentIns-EditInst";
      this.AddDonation= "first-journey-booking-redirectToSummary-editGarmentIns-addDonation";
      this.saveInstNext = "first-journey-booking-redirectToSummary-editGarmentIns-next";
    }
  }
}